<template>
  <div id="app" class="overflow-hidden">
    <breakpoint />
    <transition :name="transitionName">
      <router-view/>
    </transition>
  </div>
</template>

<script>
import breakpoint from './components/Breakpoint'

export default {
  name: 'App',
  data() {
    return {
      transitionName: null,
    }
  },
  components: {
    'breakpoint': breakpoint,
  },
  methods: {
    isDetail(path) {
      if(path[1] === 'steuerungen' || path[1] === 'beheizungen' || path[1] === 'aktoren') {
        if(path[2]) {
          return true; 
        }
      }
      return false;
    }
  },
  watch: {
    '$route' (to, from) {
      const toSplit = to.path.split('/');
      const fromSplit = from.path.split('/');
      if(to.path === '/connectivity' || from.path === '/connectivity') {
        this.transitionName = 'a-connectivity';
      } else if((to.path === '/steuerungen' || to.path === '/beheizungen' || to.path === '/aktoren') && from.path === '/') {
        this.transitionName = 'a-toList';
      } else if ((from.path === '/steuerungen' || from.path === '/beheizungen' || from.path === '/aktoren') && to.path === '/') {
        this.transitionName = 'a-fromList';
      } else if (this.isDetail(toSplit) || this.isDetail(fromSplit)) {
        this.transitionName = 'a-detail';
      } else {
        this.transitionName = null;
      }
    }
  }
}
</script>

<style lang="scss">
// scss
@import 'src/assets/scss/base.scss';
@import 'src/assets/scss/router-animation.scss';
@import 'src/assets/scss/animation.scss';
</style>
